/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { DocumentWithLinks } from '../models/document-with-links';
@Injectable({
  providedIn: 'root',
})
class DocumentsWithLinksService extends __BaseService {
  static readonly DocumentsWithLinksGetPath = '/documents-with-links/{documentId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Returns the document with links
   * @param params The `DocumentsWithLinksService.DocumentsWithLinksGetParams` containing the following parameters:
   *
   * - `documentId`: GUID of the document
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * - `includeTags`: Decides if tags should be included (optional - default false)
   *
   * @return OK
   */
  DocumentsWithLinksGetResponse(params: DocumentsWithLinksService.DocumentsWithLinksGetParams): __Observable<__StrictHttpResponse<DocumentWithLinks>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    if (params.includeTags != null) __params = __params.set('includeTags', params.includeTags.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/documents-with-links/${encodeURIComponent(String(params.documentId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DocumentWithLinks>;
      })
    );
  }
  /**
   * Returns the document with links
   * @param params The `DocumentsWithLinksService.DocumentsWithLinksGetParams` containing the following parameters:
   *
   * - `documentId`: GUID of the document
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * - `includeTags`: Decides if tags should be included (optional - default false)
   *
   * @return OK
   */
  DocumentsWithLinksGet(params: DocumentsWithLinksService.DocumentsWithLinksGetParams): __Observable<DocumentWithLinks> {
    return this.DocumentsWithLinksGetResponse(params).pipe(
      __map(_r => _r.body as DocumentWithLinks)
    );
  }
}

namespace DocumentsWithLinksService {

  /**
   * Parameters for DocumentsWithLinksGet
   */
  export interface DocumentsWithLinksGetParams {

    /**
     * GUID of the document
     */
    documentId: string;

    /**
     * Bearer JSON Web Token
     */
    Authorization: string;

    /**
     * Decides if tags should be included (optional - default false)
     */
    includeTags?: boolean;
  }
}

export { DocumentsWithLinksService }